import { NavLink } from "react-router-dom";

export default function NavItem({ to, onClick, children }) {
    return (
        <NavLink to={to} onClick={onClick} activeClassName="text-blue-500">
            <p className="block mt-4 lg:inline-block lg:mt-0 text-teal-200 hover:text-blue-500 mr-4">
                {children}
            </p>
        </NavLink>
    )
}